import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-pagination-row',
  templateUrl: './pagination-row.component.html',
  styleUrls: ['./pagination-row.component.css'],
  standalone: false
})
export class PaginationRowComponent implements OnInit {
  @ViewChild('popover', { static: false }) popover?: NgbPopover;
  @Output() onLoad = new EventEmitter<{ page: number; pageSize: number; query?: string }>();
  @Input() initialPageSize: number = 10;
  @Input() initialSearchQuery: string | undefined = undefined;

  // Filter inputs (optional)
  @Input() filterForm?: FormGroup;
  @Input() filterFields?: FormlyFieldConfig[];
  @Input() filterModel?: any;
  @Output() submitFilter = new EventEmitter<NgbPopover>();
  @Output() resetFilter = new EventEmitter<NgbPopover>();

  // Toolbar form fields (optional)
  @Input() toolbarForm?: FormGroup;
  @Input() toolbarFields?: FormlyFieldConfig[];
  @Input() toolbarModel?: any;

  searchDebounceTimeout: any;
  searchQuery?: string;
  pageSize = 10;
  selectedLines = 10;

  // Helper to check if filters are enabled
  get hasFilters(): boolean {
    return !!(this.filterForm && this.filterFields && this.filterModel);
  }

  // Helper to check if toolbar fields are enabled
  get hasToolbarFields(): boolean {
    return !!(this.toolbarForm && this.toolbarFields && this.toolbarModel);
  }

  constructor() { }

  ngOnInit() {
    // NON inizializziamo più qui pageSize e selectedLines
  }

  ngOnChanges() {
    if (this.initialPageSize != null) {
      this.selectedLines = this.initialPageSize;
      this.pageSize = this.initialPageSize;
    }

    if (this.initialSearchQuery !== undefined) {
      this.searchQuery = this.initialSearchQuery;
    }
  }

  search(query?: string) {
    const q = query?.trim() ?? '';
    clearTimeout(this.searchDebounceTimeout);

    if (q.length == 0) {
      this.searchQuery = undefined;
      this.load();
      return;
    }

    this.searchDebounceTimeout = setTimeout(() => {
      this.searchQuery = q;
      this.load();
    }, 700);
  }

  updatePageSize(newSize: number) {
    this.pageSize = newSize;
    this.selectedLines = newSize;
    this.load();
  }

  load() {
    this.onLoad.emit({
      page: 0,
      pageSize: this.pageSize,
      query: this.searchQuery
    });
  }

  numbers: any[] = [
    { value: 10, viewValue: '10' },
    { value: 25, viewValue: '25' },
    { value: 50, viewValue: '50' },
    { value: 100, viewValue: '100' },
  ];

  onFilterSubmit() {
    if (this.popover) {
      this.submitFilter.emit(this.popover);
    }
  }

  onFilterReset() {
    if (this.popover) {
      this.resetFilter.emit(this.popover);
    }
  }
}